import { render } from "./BaseErrorMessage.vue?vue&type=template&id=11478fe9&scoped=true"
import script from "./BaseErrorMessage.vue?vue&type=script&lang=js"
export * from "./BaseErrorMessage.vue?vue&type=script&lang=js"

import "./BaseErrorMessage.vue?vue&type=style&index=0&id=11478fe9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11478fe9"]])

export default __exports__